import { ModuleFE_PermissionGroup } from './ModuleFE_PermissionGroup.js';
export const ModulePackFE_PermissionGroup = [ModuleFE_PermissionGroup];
//# sourceMappingURL=module-pack.js.map